export enum ELocalStorageKeys {
	accessToken = 'vemo-access-token',
	refreshToken = 'vemo-refresh-token',
	/** @deprecated Prefer hubByScope; kept so we can remove the old key without migrating. */
	globalLocationId = 'globalLocationId',
	hubByScope = 'vemo-hub-by-scope',
}

/** Persistence scopes for LocationDropdown hub filters (one hub per screen). */
export enum ELocationScope {
	monitor = 'monitor',
	shiftHistory = 'shift-history',
	plannedShifts = 'planned-shifts',
	drivers = 'drivers',
	vehicles = 'vehicles',
	dashboards = 'dashboards',
	reports = 'reports',
	feedbackHistory = 'feedback-history',
}
